module.exports = __webpack_public_path__ + "img/hr-tree-06-i-trunk.4b5a4559.png";